import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Provider as StateProvider } from 'react-redux';
import store from './store';
import Routing from 'routes';
import Header from 'components/Header';
import NavSide from 'components/NavSide';
import Fetch from 'pages/Fetch';
import Errors from 'pages/Errors';
import './i18n';

import 'styles/index.scss';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import FontStyles from './styles/fonts';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <>
    <FontStyles />
    <StateProvider store={store}>
      <div className="App">
        <Fetch />
        <Errors />
        <Router>
          <div className="routes-container">
            <NavSide />
            <div className="routes">
              <Header />
              <Routing />
            </div>
          </div>
        </Router>
        <Toaster />
      </div>
    </StateProvider>
  </>,
);
